// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'

const pl = {
  paddingLeft: '3px',
}

const FormatThresholdHeader = () => (
  <div
    className={'display-flex flex-direction-row flex-wrap-nowrap justify-content-end'}
    title={'Threshold of highest modulation'}>
    <span>{'Thr.'}</span>
    <small style={pl}>{'(dBm)'}</small>
  </div>
)

export default FormatThresholdHeader
